<template>
	<div>
		<div
			v-if="brand"
			class="product-title"
		>
			<!-- Branding -->
			<TnHeading
				type="h2"
				size="s"
				responsive
			>
				{{ brand }}
			</TnHeading>
			<!-- title -->
			<TnHeading
				responsive
				type="h1"
				size="l"
			>
				{{ title }}
				<TnButton
					v-if="isTest"
					icon-only="edit"
					size="xs"
					secondary
					:to="editLink"
				/>
			</TnHeading>

			<!-- Model -->
			<TnParagraph
				responsive
				type="h1"
				size="m"
				v-if="(product.category === 'Tilbehør' || product.category === 'Smartklokker') && product?.model"
			>
				{{ product.model }}
			</TnParagraph>
		</div>

		<div
			v-else
			class="product-title"
		>
			<TnHeading class="title">
				{{ title }}
				<TnButton
					icon-only="edit"
					size="xs"
					secondary
					v-if="isTest"
					:to="editLink"
				/>
			</TnHeading>
		</div>
	</div>
</template>

<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
import IsTestMixin from "~/mixins/platform/IsTestMixin.js";
import { mapState, mapGetters } from "vuex";
import ECommerceProductMixin from "~/components/ecommerce/ECommerceProductMixin/ECommerceProductMixin.js";
import { ProductCategory } from "~/components/ecommerce/types/ProductCategory";
export default defineNuxtComponent({
	name: "ECommerceProductTitle",
	mixins: [GizmoComponentMixin, ECommerceProductMixin, IsTestMixin],
	props: {
		modal: {
			type: Boolean,
		},
	},

	computed: {
		...mapState("ecommerce", ["product"]),
		...mapGetters("ecommerce", ["productMemberPrice"]),
		hasBundle() {
			return (
				this.eCommerceProduct?.campaignData?.attributes?.includedItem ||
				this.eCommerceProduct?.campaignData?.attributes?.includeditem ||
				this.product?.memberPrice?.campaignData?.includedItem
			);
		},
		title() {
			const productTitle =
				this.eCommerceProduct?.cleanName || this.product?.cleanName || this.eCommerceProduct?.title || "Produkt Tittel";
			if (this.product.category === ProductCategory.ACCESSORY || this.product.category === ProductCategory.WATCH) {
				return productTitle
					.replace(new RegExp(`^${this.brand} `, "i"), "")
					.replace(new RegExp(` ${this.model}`, "i"), "");
			} else {
				return productTitle.replace(new RegExp(`^${this.brand} `, "i"), "");
			}
		},
		brand() {
			if (this.eCommerceProduct?.brand) {
				return this.eCommerceProduct.brand;
			} else if (this.product?.brand) {
				return this.product.brand;
			}
			return false;
		},
		model() {
			if (this.eCommerceProduct?.model) {
				return this.eCommerceProduct.model;
			} else if (this.product?.model) {
				return this.product.model;
			}
			return false;
		},
		editLink() {
			if (this.isTest && this.$store.state.host.indexOf("staging") > -1) {
				return `https://app.bluestonepim.com/products/${this.product.id}/`;
			} else if (this.isTest) {
				return `https://app.test.bluestonepim.com/products/${this.product.id}/`;
			}
			return "";
		},
	},
});
</script>
<style scoped lang="scss">
.product-title {
	display: flex;
	flex-direction: column;
	color: $color-neutrals-900-shade;
}
</style>
